import type { FC } from 'react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { PageLoginWithEmail } from '@components/PagesFragments/Login/PageLoginWithEmailField';
import { PageLoginWithCode } from '@components/PagesFragments/Login/PageLoginWithCode';
import { REVERSE_GROUP_LOGIN_BANNER_IMAGES } from '@app/constants/brand';
const LoginPageStep = {
  EMAIL_ADDRESS: 'emailAddress',
  VERIFICATION_CODE: 'verificationCode',
} as const;

export const PageLoginBody: FC = () => {
  const { t } = useTranslation('', {
    keyPrefix: 'login.requireLink',
  });

  const [currentLoginStep, setCurrentLoginStep] = useState<string>(
    LoginPageStep.EMAIL_ADDRESS,
  );

  const [userMail, setUserMail] = useState<string | null>(null);

  const handleFirstStepSubmit = (email: string): void => {
    setCurrentLoginStep(LoginPageStep.VERIFICATION_CODE);
    setUserMail(email);
  };

  const imageSrc = __ENVIRONMENT_CONFIG__.IS_THEME_AKI
    ? REVERSE_GROUP_LOGIN_BANNER_IMAGES.AKI
    : REVERSE_GROUP_LOGIN_BANNER_IMAGES.IT;
  const bannerImageSrc = `${__ENVIRONMENT_CONFIG__.PUBLIC_URL}${imageSrc}`;

  return (
    <div className="c-page-login__body">
      <div className="c-page-login__wrapper">
        <div className="c-page-login__banner">
          <img
            alt={t('bannerAlt')}
            className="c-page-login__banner-image"
            src={bannerImageSrc}
          />
        </div>

        <div className="c-page-login__content">
          {currentLoginStep === LoginPageStep.EMAIL_ADDRESS && (
            <PageLoginWithEmail onFormSubmit={handleFirstStepSubmit} />
          )}
          {currentLoginStep === LoginPageStep.VERIFICATION_CODE && userMail && (
            <PageLoginWithCode userMail={userMail} />
          )}
        </div>
      </div>
    </div>
  );
};
